import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import ReactDOM from "react-dom";
import { usePopoverContext } from "./PopoverContext";
export var PopoverContent = function(param) {
    var children = param.children;
    var _floatingData_middlewareData_hide, _floatingData_middlewareData_hide1;
    var _usePopoverContext = usePopoverContext(), popoverZIndex = _usePopoverContext.popoverZIndex, showDetached = _usePopoverContext.showDetached, open = _usePopoverContext.open, disableOverflow = _usePopoverContext.disableOverflow, containingElement = _usePopoverContext.containingElement, bodyRef = _usePopoverContext.bodyRef, floatingData = _usePopoverContext.floatingData, floatingInteractions = _usePopoverContext.floatingInteractions;
    if (!open) {
        return null;
    }
    if (disableOverflow || !bodyRef.current) {
        return children;
    }
    var hidden = !showDetached && (((_floatingData_middlewareData_hide = floatingData.middlewareData.hide) === null || _floatingData_middlewareData_hide === void 0 ? void 0 : _floatingData_middlewareData_hide.escaped) || ((_floatingData_middlewareData_hide1 = floatingData.middlewareData.hide) === null || _floatingData_middlewareData_hide1 === void 0 ? void 0 : _floatingData_middlewareData_hide1.referenceHidden));
    return /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: floatingData.refs.setFloating
    }, floatingInteractions.getFloatingProps()), {
        style: _object_spread_props(_object_spread({}, floatingData.floatingStyles), {
            zIndex: popoverZIndex
        }),
        hidden: hidden,
        children: children
    })), containingElement !== null && containingElement !== void 0 ? containingElement : bodyRef.current);
};
